import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import { Pagination } from 'components/Commons';

import cm from 'helpers/commons';
import ReactTable from 'react-table';
import { Popup } from 'semantic-ui-react';
import scroll from 'helpers/scroll';
import { setPaymentReasonFilter, checkedPaymentReason, checkedAllPaymentReason } from 'actions/paymentReason';

class PaymentReasonResult extends Component {
  constructor(props) {
    super(props);
    const {
      paymentReasonAction: { onAllChecked }
    } = props;
    const headers = [
      { header: '', width: 56, isChecked: true },
      { header: '결제일', width: 144 },
      { header: '이름', width: 116 },
      { header: '가맹점', width: 144 },
      { header: '회사식대 결제금액', width: 120 },
      { header: '결제사유', minWidth: 500 },
      { header: '등록자', width: 116 },
      { header: '최근 수정관리자', width: 128 }
    ];

    const header = cm.tableHeaderList(headers, 3);

    const fn = {
      fnChecked: (e, data, type) => {
        onAllChecked(e.target.checked);
      },
      move: null
    };
    const columns = scroll.header(header, fn);

    this.state = {
      headers,
      columns
    };
  }

  listItem = (item, index) => {
    const {
      paymentReasonAction: { onChecked }
    } = this.props;
    const { headers } = this.state;
    let result = null;
    if (item) {
      const division = cm.trTdDivision(item.user.orgCode);
      const styles = [];
      headers.forEach((headerItem) => {
        styles.push({
          flex: `${headerItem.width} 0 auto`,
          width: headerItem.width,
          maxWidth: headerItem.width,
          minWidth: headerItem.minWidth,
          padding: '10px 0'
        });
      });
      result = (
        <div className="rt-tr -odd" key={`row-${index}`}>
          <div className="rt-td" style={styles[0]}>
            <div className="checkbox pure">
              <label>
                <input
                  type="checkbox"
                  id={item.payment.cid}
                  name={item.payment.cid}
                  className="payment-reason-checkbox"
                  checked={item.isChecked}
                  onChange={(e) => onChecked({ checked: e.target.checked, index })}
                />
                <span />
              </label>
            </div>
          </div>
          <div className="rt-td" style={styles[1]}>
            {item.usedate}
          </div>
          <div className="rt-td" style={styles[2]}>
            {item.user.name}
          </div>
          {division.map((divi, i) => {
            return (
              <div
                key={`divi${i}`}
                className="rt-td"
                style={{ flex: `128 0 auto`, width: 128, maxWidth: 128, padding: '10px 0' }}
              >
                <Popup className="td-tooltip" inverted trigger={<span>{divi}</span>} content={divi} />
              </div>
            );
          })}
          <div className="rt-td" style={styles[3]}>
            {item.store.name}
          </div>
          <div className="rt-td" style={styles[4]}>
            {cm.numberComma(item.price.total)}
          </div>
          <div className="rt-td" style={styles[5]}>
            {item.payment.paymentReason}
          </div>
          <div className="rt-td" style={styles[6]}>
            {item.payment.createUserName}
          </div>
          <div className="rt-td" style={styles[7]}>
            {item.payment.updateAdminName}
          </div>
        </div>
      );

      return result;
    }
    return null;
  };

  buildElements = (st, en, item) => {
    const elements = [];
    for (let i = st; i < en; i++) {
      const temp = this.listItem(item[i], i);
      if (temp) {
        elements.push(temp);
      }
    }
    return elements;
  };

  tBodyFunc = (state) => {
    const { reasons } = this.props;
    return (
      <div className="rt-tbody" style={state.style}>
        <div className="rt-tr-group">
          {reasons && reasons.length ? (
            reasons.map((reason, i) => this.listItem(reason, i))
          ) : (
            <div className="rt-tr -odd" key="empty-row">
              <div
                className="rt-td"
                style={{
                  flex: '1 0 auto',
                  height: '42px',
                  width: '100%',
                  maxWidth: '100%',
                  padding: '10px 0'
                }}
              />
            </div>
          )}
        </div>
      </div>
    );
  };

  noDataProps = () => {
    const { reasons } = this.props;
    let dom = <div className="rt-noData">검색 결과가 없습니다.</div>;
    if (reasons && reasons.length > 0) {
      dom = <div className="rt-noData" />;
    }

    return dom;
  };

  render() {
    const {
      handlePage,
      filter: { page, pageRow, totalCount }
    } = this.props;
    const { columns } = this.state;

    return (
      <div className="payment-reason-table-container">
        <div className="table-box">
          <ReactTable
            className="react-table"
            // noDataText="검색 결과가 없습니다."
            columns={columns}
            sortable={false}
            resizable={false}
            showPagination={false}
            TbodyComponent={this.tBodyFunc}
            NoDataComponent={this.noDataProps}
          />
        </div>

        <div className="table-paging">
          <Pagination page={page} pageRow={pageRow} pageBlock={10} totalCount={totalCount} pageClick={handlePage} />
        </div>
      </div>
    );
  }
}

export default connect(
  (state) => ({
    filter: state.paymentReason.searchFilter,
    reasons: state.paymentReason.paymentReasonList
  }),
  (dispatch) => ({
    paymentReasonAction: bindActionCreators(
      {
        onFilterChange: setPaymentReasonFilter,
        onChecked: checkedPaymentReason,
        onAllChecked: checkedAllPaymentReason
      },
      dispatch
    )
  })
)(PaymentReasonResult);
